import {  getRequest } from "./RequestConfig";

export const getDCList = async () => {
  try {
    const response = await getRequest("debi/distribution/list");
    return response;
  } catch (error) {
    throw error;
  }
};
